import { page as pageIndex } from '../../globals'
import {
  matchParameters,
  returnDateFormat,
  filterRegions,
  returnTextValuesForClearedFilters } from './helpers'
import {
  START_DATA_FETCH,
  DATA_FETCHED,
  FETCH_FAILED,
  OPEN_SAVED_REPORT,
  getFormDataHandlers
} from './getFormData'
import { UPDATE_DATA, actionHandler } from './updateData'
import { CLEAR_FILTERS } from './reportLine'
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [START_DATA_FETCH] : getFormDataHandlers['START_DATA_FETCH'],
  [FETCH_FAILED] : getFormDataHandlers['FETCH_FAILED'],
  [DATA_FETCHED] : (state, action) => {
    const { page, field } = action.location
    const { json } = action.payload
    if (page !== pageIndex.billFinder) {
      return state
    }
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        [page]: {
          ...state.renderData[page],
          [field]: {
            clientId: json.ClientId,
            userId: json.UserId,
            regionList: filterRegions(json.RegionList),
            archiveStartYear: json.ArchiveStartYear,
            defaultReport: json.DefaultReport,
          }
        }
      },
      formDataValue: {
        ...state.formDataValue,
      }
    }
  },
  [UPDATE_DATA] : (state, action) => action.location.page !== pageIndex.billFinder
    ? state
    : actionHandler(state, action),
  [OPEN_SAVED_REPORT] : (state, action) => {
    const { page } = action
    const { json } = action.payload
    if (page !== pageIndex.billFinder || json === undefined) {
      return {
        ...state,
      }
    } else {
      const criteria = matchParameters(json.ReportCriteria)
      return {
        ...state,
        isFetchingData: false,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            defaultSearch: {
              ...state.formDataValue[page].defaultSearch,
              title: json.Name,
              textValues: {
                reporttitle: criteria.filters.reporttitle || '',
                ti1t: ''
              },
              radio: {
                reporttype: criteria.filters.reporttype[0] || 'all',
              },
            },
            states: {
              selected: criteria.filters.states ? criteria.filters.states : []
            },
            viewingOptions: {
              selected: criteria.viewingOptions.selected || [],
              radio: {
                howmany: criteria.viewingOptions.howmany || '25',
              },
            },
            advancedEditingTools: {
              selected: criteria.advancedEditingTools.selected || [],
              radio: {
                sortheader: !!criteria.advancedEditingTools.sortheader,
                sort1: criteria.advancedEditingTools.sort1[0] || 'score',
              }
            },
            archivedYear: {
              selected: criteria.filters.archive ? criteria.filters.archive : ['current'],
            },
            searchRequest: {
              selected: [],
              textValues: {
                request: criteria.filters.request ? criteria.filters.request : '',
              }
            },
            searchResults: {
              radio: {
                maxFiles: criteria.filters.maxFiles ? criteria.filters.maxFiles : '100',
              }
            },
            additionalFilters: {
              selected: [],
              textValues: {},
              dateTime: {
                moddatestart: criteria.filters.moddatestart
                  ? returnDateFormat(criteria.filters.moddatestart[0]) : ' ',
                moddateend: criteria.filters.moddateend
                  ? returnDateFormat(criteria.filters.moddateend[0]) : ' ',
                createdatestart: criteria.filters.createdatestart
                  ? returnDateFormat(criteria.filters.createdatestart[0]) : ' ',
                createdateend: criteria.filters.createdateend
                  ? returnDateFormat(criteria.filters.createdateend[0]) : ' ',
              },
              radio: {
                fuzziness: criteria.filters.fuzziness ? criteria.filters.fuzziness : '5',
              }
            },
          },
        },
        renderData: {
          ...state.renderData,
          [page]: {
            ...state.renderData[page],
            groupNotes: {
              ...state.renderData[page].groupNotes,
              selectedReport: json,
            }
          }
        }
      }
    }
  },
  [CLEAR_FILTERS] : (state, action) => {
    const { page } = action
    if (page !== pageIndex.billFinder) {
      return state
    }
    return {
      ...state,
      isFetchingData: false,
      formDataValue: {
        ...state.formDataValue,
        [page]: {
          ...clearState.formDataValue[page],
          groupNotes: {
            ...clearState.formDataValue[page].groupNotes,
            textValues: returnTextValuesForClearedFilters
          }
        }
      }
    }
  },
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetchingData: true,
  errorCode: '',
  renderData: {
    F: {
      groupNotes: {},
    },
  },
  formDataValue: {
    F: {
      viewingOptions: {
        selected: ['viewsearchcriteria', 'viewscore', 'viewhits'],
        radio: {
          howmany: '25',
        },
      },
      defaultSearch : {
        title: 'Default Search',
        textValues: {
          reporttitle: 'Legislative Text Search Report',
          ti1t: '',
        },
        radio: {
          reporttype: 'all',
        },
      },
      additionalFilters: {
        selected: [],
        textValues: {},
        dateTime: {
          moddatestart: ' ',
          moddateend: ' ',
          createdatestart: ' ',
          createdateend: ' ',
        },
        radio: {
          fuzziness: '5',
        }
      },
      advancedEditingTools: {
        selected: [],
        radio: {
          sortheader: false,
          sort1: 'Score',
        }
      },
      reportFormat: {
        selected: [],
        radio: {
          mapit: false,
          outformat: 'html',
        }
      },
      billType: {
        selected: [],
      },
      states: {
        selected: [],
      },
      searchRequest: {
        selected: [],
        textValues: {
          request: ''
        }
      },
      searchResults: {
        radio: {
          maxFiles: '100',
        }
      },
      maps: {
        selected: [],
        textValues: {
          lowcountcolor: '#9cc1e6',
          medcountcolor: '#4175b2',
          highcountcolor: '#243e66',
          foundbillscolor: '#4175b2',
        },
      },
      archivedYear: {
        selected: ['current'],
      },
      'Synonym expansion': {
        selected: [],
      },
      'Phonic searching': {
        selected: [],
      },
      'No Stemming': {
        selected: [],
      },
      'Fuzzy searching': {
        selected: [],
      }
    },
  },
}
const clearState = {
  isFetchingData: true,
  errorCode: '',
  renderData: {
    F: {
      groupNotes: {},
    },
  },
  formDataValue: {
    F: {
      viewingOptions: {
        selected: [],
        radio: {
          howmany: '25',
        },
      },
      defaultSearch : {
        title: 'Default Search',
        textValues: {
          reporttitle: '',
          ti1t: '',
        },
        radio: {
          reporttype: 'all',
        },
      },
      additionalFilters: {
        selected: [],
        textValues: {},
        dateTime: {
          moddatestart: ' ',
          moddateend: ' ',
          createdatestart: ' ',
          createdateend: ' ',
        },
        radio: {
          fuzziness: '5',
        }
      },
      advancedEditingTools: {
        selected: [],
        radio: {
          sortheader: false,
          sort1: 'state',
        }
      },
      reportFormat: {
        selected: [],
        radio: {
          mapit: false,
          outformat: 'html',
        }
      },
      billType: {
        selected: [],
      },
      states: {
        selected: [],
      },
      searchRequest: {
        selected: [],
        textValues: {
          request: ''
        }
      },
      searchResults: {
        radio: {
          maxFiles: '100',
        }
      },
      maps: {
        selected: [],
        textValues: {
          lowcountcolor: '#9cc1e6',
          medcountcolor: '#4175b2',
          highcountcolor: '#243e66',
          foundbillscolor: '#4175b2',
        },
      },
      archivedYear: {
        selected: ['current'],
      },
      'Synonym expansion': {
        selected: [],
      },
      'Phonic searching': {
        selected: [],
      },
      'No Stemming': {
        selected: [],
      },
      'Fuzzy searching': {
        selected: [],
      }
    },
  },
}
export default function billFinderDataReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/billFinderFormData.js